import styled from '@bd/bdui-styles/emotion';
import FavoritesCategories from '../../bdcoreCandidates/Favorites';
import { colors, typography } from '../../styles';

export default styled(FavoritesCategories)`
  width: 100%;
  background-color: ${colors.white};
  color: ${colors.bodyLightest};
  font:700 18px/1 ${typography.SansSerif};
  text-align: center;
  position:relative;
  z-index: 6;

  @media (min-width: 992px) {
    background-size: cover;
  }

  .FavoritesCategories {
  }
  .FavoritesCategories_categories {
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: center;
  }
  .FavoritesCategories_categoriesItem {
    padding: 0;
    margin: 0;
    list-style: none;
    cursor: pointer;
    border: 1px solid ${colors.brand1};

    span {
      display: block;
      padding: 15px 25px;
    }
  }
  .FavoritesCategories_list {
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: center;
  }

  .FavoritesCategories_listItem {
    margin: 0;
    list-style: none;
    padding: 15px 25px;
  }
  .PageMenu_title {
    width: auto;
    background-image: url(/images/icon-triangle-gold.svg);
    background-repeat: no-repeat;
    background-position: 92% center;
    display: inline-block;
    padding:15px 30px 15px 15px;
    color: white;
    font-weight: 800;
    @media (min-width: 992px) {
      display: none;
    }
  }
  .PageMenu_list {
    display: none;
    padding: 0;
    text-align: left;
    width: 300px;
    position: absolute;
    left: 50%;
    margin-left: -150px;
    top: 54px;
    list-style: none;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.25);
    z-index: 1;
    &.open {
      display: block;
    }
    @media (min-width: 992px) {
      list-style: none;
      margin: 14px 0;
      display: block;
      position: relative;
      width: auto;
      left: auto;
      margin-left: 0;
      top: auto;
      box-shadow: none;
      text-align: center;
    }
  }
  .PageMenu_listItem {
    @media (min-width: 992px) {
      display: inline-block;
    }
    span {
      background-color: ${colors.white};
      padding: 15px;
      border-bottom: 1px solid ${colors.neutral};
      display: block;
      color: ${colors.brand1};
      transition: all .25s ease;
      outline:none;
      cursor:pointer;
      @media (min-width: 992px) {
          background-color: transparent;
          text-align: center;
          color: ${colors.brand1};
          padding:15px;
          border: 0;
          &.active {
            color: ${colors.brand2};
          }
        }
    }
    span:hover, span:active, span:focus {
      color: ${colors.brand2};
    }
  }
  .Cards_Wrap {
    background-color: ${colors.white};
    display:flex;
    flex-flow:row wrap;
    justify-content: center;
    position: relative;
    z-index: 0;
    margin-bottom: 100px;
    &-lot {
      max-width: 75%;
      margin: 0 auto;
      .col-12:nth-child(even) .stripes {
        background-color:  ${colors.brand3Lightest};
      }
    }
  }
  .VideoGallery_List {
    position: relative;
    z-index: 0;
    background:${colors.brand4};
  }
  .PhotoCard {
    width:100%;
    position: relative;
    padding:0;
    padding-top:56%;
    background-size: cover;
    background-position: center;
    border:1px solid ${colors.brand3};
  }
  .PlayIcon {
    position:absolute;
    top:50%;
    margin-top:-30px;
    left:50%;
    margin-left:-30px;
    width:60px;
    height:60px;
    border-radius: 50%;
    border:4px solid white;
    text-align: center;
    display: flex;
    flex-flow:column wrap;
    justify-content: center;
    background:rgba(0,0,0,.4);
    .PlayIcon_triangle {
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-left: 10px solid white;
      margin: 0 auto;
    }
  }
  .FavoriteToggle {
    width: 30px;
    background: url(/images/icon-heart.svg);
    height: 30px;
    background-repeat: no-repeat;
    transition: all .25s ease;
    background-position: right;
  }

  }
  .FavoriteToggle-active {
    background: url(/images/icon-heart-full.svg);
  }
  .Favorite_circle {
    width:40px;
    height:40px;
    background:rgba(0,0,0,.4);
    padding: 4px;
    position: absolute;
    top:10px;
    right:10px;
    z-index: 5;
    border-radius:50%;
    display:flex;
    flex-flow:column nowrap;
    justify-content: center;
    text-align: center;
    cursor;pointer;

    &-edit {
      right: 55px;
    }
  }
  .FavoritesActions {
    display:flex;
    flex-flow:row wrap;
    justify-content: flex-start;
    background:${colors.brand4};
    padding:20px;
    border-bottom:1px solid ${colors.brand3};
    border-top:1px solid ${colors.brand3};

    .FavoritesUpload_button {
      display: inline-block;
      line-height: 38px;
      height: 40px;
      margin: 0 10px 0 0;
      cursor: pointer;
      color: white;
      font-size: 14px;
      font-weight: 700;
      text-align: center;
      border: 0;
      padding: 0 10px;
      border: 1px solid black;
      border-radius: 5px;
      background-color:${colors.brand3};
      transition:all .25s ease;
      img {
        height: 20px;
        width: auto;
        margin: 0 10px 0 0;
      }
      &:focus, &:hover {
        outline: 0;
        box-shadow: 0;
        background-color: ${colors.brand2};
        color: ${colors.white};
      }
    }
  }

  .ClientLogin_logout .btn, .FavoritesUpload .btn {
    display: inline-block;
    line-height: 38px;
    height: 40px;
    margin: 0 10px 0 0;
    cursor: pointer;
    color: white;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    border: 0;
    padding: 0 10px 0 10px;
    border: 1px solid black;
    border-radius: 5px;
    background-image: url('/images/icon-triangle-green.svg');
    background-position: calc(100% - 12px) center;
    background-repeat: no-repeat;
    background-color:${colors.brand3};
    transition:all .25s ease;
    outline: 0;
    &:focus, &:hover {
      outline: 0;
      box-shadow: 0;
      background-color: ${colors.brand2};
      color: ${colors.white};
    }
  }

  .FavoriteCardWrap {
    position: relative;
  }
  .FavoriteEditWrap {
    padding:4px;
    text-align: left;

    textarea {
      background:${colors.body};
      border:1px solid black;
      border-radius: 0;
      margin-bottom:4px;
      width:100%;
      height:50px;
      color:white;
    }
  }
  .FavoriteUpload {
    padding-bottom:20px;
    background:white;
    position: absolute;
    z-index: 90;
    max-width: 300px;
  }

  .FavoriteUpload_formSection {
    display:flex;
    flex-flow:row wrap;
    justify-content: center;

    .form-group {
      width:100%;
      padding:10px;
      text-align: left;
      margin:0;


      label {
        font-weight:700;
        color:${colors.body};
      }

      textarea.form-control {
        height: 60px;
      }

      .btn.disabled, .btn:disabled {
        opacity: .65;
      }

    }
  }
  .no-border {
    border:0;
    padding:0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Favorites/FavoritesCategories.js